import React from 'react'
import { useRegistration } from '@account/hooks/useRegistration'
import { StepName } from '@account/components/Register/types'

export interface RegisterContextType extends ReturnType<typeof useRegistration> {
  submit: (stepName?: StepName, newPayload?: any) => Promise<void>
}

export const RegisterContext = React.createContext<RegisterContextType | undefined>(undefined)
